module.exports = __webpack_public_path__ + "img/bz.bz9e8153a.svg";